// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo_root__3yyn_","light":"Logo_light__j7ELL","dart":"Logo_dart__6yQxC"};